import React, { createRef } from 'react';
import PropTypes from 'prop-types';

import { KeyCodeConstants } from 'javascripts/shared/key_code_constants';

export function AccessibleRadioButtonGroup({ groupClass, label, onSelect, options, RadioComponent, selectedValue }) {
  const optionRefs = _.reduce(
    options,
    (map, option) => {
      map[option.value] = createRef();
      return map;
    },
    {},
  );

  function nextRadioId() {
    let activeIndex = _.findIndex(options, { value: selectedValue });
    activeIndex = activeIndex === -1 ? 0 : activeIndex;
    const nextIndex = (activeIndex + 1) % options.length;
    return options[nextIndex].value;
  }

  function previousRadioId() {
    let activeIndex = _.findIndex(options, { value: selectedValue });
    activeIndex = activeIndex === -1 ? 0 : activeIndex;
    const previousIndex = (activeIndex + options.length - 1) % options.length;
    return options[previousIndex].value;
  }

  function changeSelection(value, event) {
    event.preventDefault();
    onSelect(value);
    optionRefs[value].current.focus();
  }

  function onKeyDown(event) {
    switch (event.keyCode) {
      case KeyCodeConstants.ENTER:
      case KeyCodeConstants.SPACE_BAR:
        changeSelection(selectedValue, event);
        break;
      case KeyCodeConstants.ARROW_LEFT:
      case KeyCodeConstants.ARROW_UP:
        changeSelection(previousRadioId(), event);
        break;
      case KeyCodeConstants.ARROW_RIGHT:
      case KeyCodeConstants.ARROW_DOWN:
        changeSelection(nextRadioId(), event);
        break;
      default:
    }
  }

  return (
    <div role='radiogroup' className={groupClass} aria-label={label}>
      {_.map(options, (option, idx) => {
        return (
          <div key={option.value}>
            <RadioComponent
              radioRef={optionRefs[option.value]}
              onKeyDown={onKeyDown}
              onSelect={onSelect}
              overrideIndex={!selectedValue ? idx === 0 : false}
              selected={option.value === selectedValue}
              {...option}
            />
          </div>
        );
      })}
    </div>
  );
}

AccessibleRadioButtonGroup.propTypes = {
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  groupClass: PropTypes.string,
  label: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
    }),
  ).isRequired,
  RadioComponent: PropTypes.func,
};
